module.exports = __webpack_public_path__ + "img/ordinary-bg.9644f71e.jpg";